import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Expertise from './components/Expertise';
import Agent from './components/Agent';
import Demo from './components/Demo';
import Contact from './components/Contact';
import Footer from './components/Footer';
import "./firebase"; // we just need it to run and initialize

function App() {
  useEffect(() => {
    const mediaQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let prefersReduced = mediaQuery?.matches ?? false;

    const handleMediaQueryChange = () => {
      prefersReduced = mediaQuery?.matches ?? false;
    };

    mediaQuery?.addEventListener('change', handleMediaQueryChange);

    const anchors = Array.from(document.querySelectorAll('a[href^="#"]'));
    const handleAnchorClick = (event) => {
      const hash = event.currentTarget.getAttribute('href');
      if (!hash || hash === '#') {
        return;
      }
      const id = hash.slice(1);
      const target = document.getElementById(id);
      if (!target) {
        return;
      }
      event.preventDefault();
      const offset = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({
        top: offset,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
    };

    anchors.forEach((anchor) =>
      anchor.addEventListener('click', handleAnchorClick)
    );

    return () => {
      mediaQuery?.removeEventListener('change', handleMediaQueryChange);
      anchors.forEach((anchor) =>
        anchor.removeEventListener('click', handleAnchorClick)
      );
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <main id="top">
        <Hero />
        <Expertise />
        <Agent />
        <Demo />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
